import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { IntlLink } from './Common/IntlComponents'

const PendingSubscriptionPaymentPopUp = () => {
  const [open, setOpen] = useState(false)

  const setState = function () {
    setOpen(true)
  }

  useEffect(() => {
    window.addEventListener('showPendingSubscriptionPayment', setState)
    return () => {
      window.removeEventListener('showPendingSubscriptionPayment', setState)
    }
  }, [])

  return (
    <Dialog open={open}>
      <DialogTitle>
        <FormattedMessage id='pendingPayment.title' />
      </DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          <FormattedMessage id='pendingPayment.description1' />
        </Typography>
        <Typography gutterBottom>
          <FormattedMessage id='pendingPayment.description2' />
        </Typography>
        <Typography>
          <FormattedMessage id='pendingPayment.description3' />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          to={'/user-area/payment-method'}
          component={IntlLink}
          onClick={() => setOpen(false)}
        >
          <FormattedMessage id='pendingPayment.updatePaymentMethod' />
        </Button>
        <Button color='secondary' onClick={() => setOpen(false)}>
          <FormattedMessage id='pendingPayment.understand' />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PendingSubscriptionPaymentPopUp
